import { ThemeModule } from '../../front/lib/ThemeModule';
export class SiteFooter extends ThemeModule {
    init() {
        const clientsEl = this.getElementById('clients');
        if (clientsEl) {
            this.initClientsSlider(clientsEl);
        }
        const form = this.querySelector('form.siteFooterMod-search');
        if (form) {
            const inputEl = form.querySelector('input[type="search"]');
            const submitEl = form.querySelector('button[type="submit"]');
            const onInput = () => {
                if (inputEl.value) {
                    submitEl.removeAttribute('disabled');
                }
                else {
                    submitEl.setAttribute('disabled', 'disabled');
                }
            };
            onInput();
            inputEl.addEventListener('input', onInput);
        }
    }
    async initClientsSlider(rootEl) {
        const { Swiper } = await import('swiper');
        const { Autoplay } = (await import('swiper/modules'));
        const slider = new Swiper(rootEl, {
            modules: [Autoplay],
            autoplay: {
                delay: 5000,
                pauseOnMouseEnter: true,
            },
            loop: true,
            slidesPerView: 7,
            spaceBetween: 15,
            breakpoints: {
                320: {
                    slidesPerView: 3,
                },
                520: {
                    slidesPerView: 5,
                },
                1024: {
                    slidesPerView: 7,
                }
            }
        });
        return slider;
    }
}
